<template>
  <BoardView
    :pagination="pagination"
    :title="$t('title')"
    :total="total">
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <RecordArticleImport
        v-for="article in results"
        :key="article.id"
        :article="article"
        :getRemoteArticles="getRemoteArticles" />
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordArticleImport from './components/RecordArticleImport'
import Table from '@mixins/Table'
import { actions } from '@utils'

export default {
  mixins: [Table],
  components: { RecordArticleImport },
  data() {
    return {
      paginationOptions: {
        name: 'adminArticleImport',
        service: 'article',
        searchIn: [
          'title',
          'topic',
        ],
        tabs: [
          {
            label: this.$t('all'),
            value: null,
          },
          {
            label: this.$t('withoutRemote'),
            append: () => ({
              remoteArticleId: null,
            }),
            value: null,
          },
        ],
        tabsIndexes: [0],
      },
      remoteArticlesBySite: {},
    }
  },
  methods: {
    async getRemoteArticles(siteId) {
      if (!this.remoteArticlesBySite[siteId]) {
        this.remoteArticlesBySite[siteId] = await this
          .FIND_REMOTE_ARTICLE({ siteId })
      }

      return this.remoteArticlesBySite[siteId]
    },
    ...actions(
      'FIND_REMOTE_ARTICLE',
    ),
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Import articles",
    "importFromSite": "Import from site",
    "all": "All",
    "withoutRemote": "Without a remote article"
  }
}
</i18n>
